import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CloudApiService } from './cloud-api.service';
import { environment } from '../../../environments/environment';
import { IPingService, PING_LIMITS, PingRequest, PingResult } from 'src/api/ping.service.interface';

/**
 * Cloud mode adapter for network diagnostics.
 * Posts to the DeviceRegistry.Api endpoint, which relays the test to the device over the
 * WebSocket tunnel — the ping itself always runs on the processor.
 *
 * Instantiated per-component with a deviceId set via setDeviceId().
 */
@Injectable()
export class CloudPingService implements IPingService {
    private http = inject(HttpClient);
    private cloudApi = inject(CloudApiService);

    private _deviceId = '';

    setDeviceId(deviceId: string): void {
        this._deviceId = deviceId;
    }

    private authHeaders(): HttpHeaders {
        const token = this.cloudApi.token();
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        if (token) headers = headers.set('Authorization', `Bearer ${token}`);
        return headers;
    }

    async networkPing(request: PingRequest): Promise<PingResult> {
        const body = {
            host: request.host,
            count: request.count ?? PING_LIMITS.defaultCount,
            timeoutMs: request.timeoutMs ?? PING_LIMITS.defaultTimeoutMs,
            port: request.port ?? 0,
            ports: request.ports ?? '',
            portTimeoutMs: request.portTimeoutMs ?? PING_LIMITS.defaultPortTimeoutMs,
            resolveDns: request.resolveDns ?? true
        };

        return firstValueFrom(this.http.post<PingResult>(`${environment.apiBaseUrl}/devices/${this._deviceId}/diagnostics/ping`, body, { headers: this.authHeaders() }));
    }
}
